// Waterleak-Geraeteliste fuer /zuhause/waterleak + /zuhause/sensoren
// (History page-lokal). Bei einem Leck zaehlt jede Sekunde: der Stand kommt
// mit jeder Meldung des Geraets, nicht erst mit einem Takt.
//
// Datenfluss: kein eigener Abruf mehr -- die Liste kommt aus dem gemeinsamen
// Sensoren-Stand (lib/sensoren.svelte.ts), den das Homelab-Protokoll (Topic
// sensor.stand, docs/protokoll.md › „Sensoren über das Protokoll“) speist.
// REST nur beim Start, als Revalidator, nach Aktionen und als Neuversuch --
// dort. Bis 02.11.2026 holte dieser Store alle 30 s (und bei jedem WS-Signal
// "waterleak") GET /v2-api/waterleak.

import { getWasserGeraete, refreshSensoren, startSensoren } from "./sensoren.svelte";
import type { WaterleakDevice } from "./types";

let _aus: (() => void) | undefined;

export function startWaterleakSummary(): void {
  if (_aus) return;
  _aus = startSensoren();
}

export function stopWaterleakSummary(): void {
  _aus?.();
  _aus = undefined;
}

export function getWaterleakSummary(): WaterleakDevice[] | undefined {
  return getWasserGeraete();
}

export async function refreshWaterleakSummary(): Promise<void> {
  await refreshSensoren("wasser");
}
